import { render, staticRenderFns } from "./input-comment.vue?vue&type=template&id=6d598214&scoped=true&"
import script from "./input-comment.vue?vue&type=script&lang=js&"
export * from "./input-comment.vue?vue&type=script&lang=js&"
import style0 from "./input-comment.vue?vue&type=style&index=0&id=6d598214&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d598214",
  null
  
)

export default component.exports